class SelectEdition {
  constructor(container$) {
    this.container$ = container$;

    this.container$.find('[data-voc-krammer-select-edition-link]').on('click', this.changeEdition.bind(this));
  }

  changeEdition(event) {
    var el$            = $(event.target).parent();
    var currentEdition = Voonto.getInstance().lookup('vocento.site.editions').current;
    var edition        = this.container$.find('input[type=radio]:checked').val();
    var url            = el$.attr('href').replace(currentEdition, edition);
    el$.attr('href', url);
  }
}

export default SelectEdition;



// WEBPACK FOOTER //
// ./src/views/select-edition.js